import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { useDispatch } from 'react-redux';

import { fetchSelectedDocuments } from '../../../actions/DocumentRepositoryActions';
import DocumentSearchTable from '../../../components/DocumentSearchTable';
import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  container: {
    padding: 24,
  },
  scrollView: {
    height: 'calc(100vh - 72px)',
    overflowY: 'auto',
  },
  documentTableHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  documentsTitle: {
    paddingTop: 10,
  },
  selectContainer: {
    '& thead > tr > th:nth-child(1) > svg': {
      display: 'none !important',
    },
    '& thead > tr > th:nth-child(2) > svg': {
      display: 'none !important',
    },
  },
});

const DocumentSearchTableWrapper = ({
  selectedRepositoryItem = {},
  selectedDocuments,
  setSelectedDocuments,
}) => {
  const translateString = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const { repositoryName } = selectedRepositoryItem;

  const handleDownloadDocuments = async (e) => {
    e.preventDefault();
    dispatch(fetchSelectedDocuments(selectedDocuments));
  };

  return (
    <div className={classes.scrollView}>
      <Grid container className={classes.container}>
        <Grid item xs={12} className={classes.documentTableHeader}>
          <Typography variant="h2" className={classes.documentsTitle}>
            {translateString(repositoryName)}
          </Typography>
          {selectedDocuments.length ? (
            <Button variant="primary" onClick={handleDownloadDocuments}>
              {translateString('Download')}
            </Button>
          ) : null}
        </Grid>
        <Grid item xs={12} className={classes.selectContainer}>
          <DocumentSearchTable
            selectedRepositoryItem={selectedRepositoryItem}
            selectedDocuments={selectedDocuments}
            setSelectedDocuments={setSelectedDocuments}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default DocumentSearchTableWrapper;
